import React from 'react';
import { Box, Button, Stack } from '@mui/material';
import { ACCOUNT_COLORS } from '../../../components/account/accountPageStyles';

export const CWY_PERCENT_OPTIONS = [25, 50, 75, 100] as const;

interface CwyAmountPercentPickerProps {
  balance: number | null;
  disabled?: boolean;
  onSelectAmount: (amount: string) => void;
}

function formatAmount(value: number): string {
  return parseFloat(value.toFixed(9)).toString();
}

export const CwyAmountPercentPicker: React.FC<CwyAmountPercentPickerProps> = ({
  balance,
  disabled,
  onSelectAmount,
}) => {
  const handlePercent = (percent: number) => {
    if (balance == null || balance <= 0) return;
    const amount = percent === 100 ? balance : (balance * percent) / 100;
    onSelectAmount(formatAmount(amount));
  };

  return (
    <Stack direction="row" spacing={1.25} flexWrap="wrap" useFlexGap sx={{ mb: 2 }}>
      {CWY_PERCENT_OPTIONS.map((percent) => (
        <Button
          key={percent}
          size="small"
          variant="outlined"
          disabled={disabled || balance == null || balance <= 0}
          onClick={() => handlePercent(percent)}
          sx={{
            minWidth: 68,
            borderRadius: '100px',
            textTransform: 'none',
            fontWeight: 600,
            fontSize: '0.875rem',
            py: 0.75,
            borderColor: ACCOUNT_COLORS.borderSoft,
            color: ACCOUNT_COLORS.textLo,
            '&:hover': {
              borderColor: ACCOUNT_COLORS.gold,
              bgcolor: ACCOUNT_COLORS.goldDim,
              color: ACCOUNT_COLORS.goldBright,
            },
          }}
        >
          {percent === 100 ? 'Max' : `${percent}%`}
        </Button>
      ))}
      {balance != null && (
        <Box sx={{ alignSelf: 'center', fontSize: '0.8125rem', color: ACCOUNT_COLORS.textMuted, ml: 0.5 }}>
          Balance: {balance.toLocaleString()} CWY
        </Box>
      )}
    </Stack>
  );
};
